import type { ReactNode } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import type { Section } from '@manaro/contracts'
import { RequireAuth } from '@/features/auth/require-auth.tsx'
import { RequireSection } from '@/features/auth/require-section.tsx'
import { DashboardPage } from '@/pages/dashboard-page.tsx'
import { InvitePage } from '@/pages/invite-page.tsx'
import { LoginPage } from '@/pages/login-page.tsx'
import { PromoCodePage } from '@/pages/promo-code-page.tsx'
import { PromoCodesPage } from '@/pages/promo-codes-page.tsx'
import { ReferralOwnerPage } from '@/pages/referral-owner-page.tsx'
import { ReferralsPage } from '@/pages/referrals-page.tsx'
import { SalonsPage } from '@/pages/salons-page.tsx'
import { StaffPage } from '@/pages/staff-page.tsx'
import { SupportLivePage } from '@/pages/support-live-page.tsx'
import { SupportPage } from '@/pages/support-page.tsx'
import { UpdatesPage } from '@/pages/updates-page.tsx'
import { AdminLayout } from '@/widgets/admin-layout.tsx'

const guard = (section: Section, page: ReactNode) => <RequireSection section={section}>{page}</RequireSection>

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/invite" element={<InvitePage />} />

      <Route element={<RequireAuth />}>
        <Route element={<AdminLayout />}>
          <Route index element={guard('overview', <DashboardPage />)} />
          <Route path="updates" element={guard('updates', <UpdatesPage />)} />
          <Route path="support" element={guard('support', <SupportPage />)} />
          <Route path="support/live/:id?" element={guard('support-live', <SupportLivePage />)} />
          <Route path="salons" element={guard('salons', <SalonsPage />)} />
          <Route path="referrals" element={guard('referrals', <ReferralsPage />)} />
          <Route path="referrals/:code" element={guard('referrals', <ReferralOwnerPage />)} />
          <Route path="promo-codes" element={guard('promo-codes', <PromoCodesPage />)} />
          <Route path="promo-codes/:id" element={guard('promo-codes', <PromoCodePage />)} />
          <Route path="staff" element={guard('staff', <StaffPage />)} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
